(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('MattingModalController', MattingModalController);

    MattingModalController.$inject = ['$uibModalInstance', 'entity', '$timeout', 'ImageService', 'QiniuToken', 'MessageService'];

    function MattingModalController($uibModalInstance, entity, $timeout, ImageService, QiniuToken, MessageService) {
        var vm = this;
        vm.token = '';
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });
        vm.domain = localStorage.getItem('editor-domain');
        var CONFIG = {
            MASK_GREEN: { r: 16, g: 141, b: 254 },
            MAX_HISTORY: 20,
            MIN_ZOOM: 0.3, MAX_ZOOM: 5, ZOOM_STEP: 0.08,
            MAX_UPLOAD_BYTES: 20 * 1024 * 1024,
        };

        // ==================== UI 绑定属性 ====================
        vm.brushSize = 20;
        vm.hardness = 80;
        vm.opacity = 100;
        vm.toolMode = 'repair';
        vm.panMode = false;
        vm.zoomPercent = '100%';
        vm.undoEnabled = false;
        vm.redoEnabled = false;
        vm.brushHintVisible = false;

        // ==================== 内部状态 ====================
        var state = {
            isDrawing: false,
            history: [], historyIndex: -1,
            displayW: 0, displayH: 0,
            originalImg: null, maskImg: null,
            initialMask: null,
            zoom: 1, panX: 0, panY: 0,
            isPanning: false, panStart: null, panScreenStart: null,
            spaceHeld: false,
            isPinching: false, pinchStartDist: 0, pinchLastMid: null,
            activeSide: 'left',
        };

        // DOM 引用
        var imageCanvas, imageCtx, overlayCanvas, overlayCtx;
        var effectCanvas, effectCtx, effectOverlay, effectOverlayCtx;
        var brushCursorL, brushCursorR;
        var wrapperL, wrapperR, canvasContainer, loadingOverlay;
        var maskCanvas, maskCtx;
        var strokeCanvas, strokeCtx, strokeBaseCanvas, strokeBaseCtx, strokeAlphaData;
        var effectPatchCanvas, effectPatchCtx;
        var canvasFloats;
        var brushTipCache = null, brushTipCacheKey = '';
        var cursorHideTimer = null;
        var hintTimer = null;
        var undoRedoDigestTimer = null;

        // ==================== 公开方法 ====================
        vm.close = function() { $uibModalInstance.close('cancel'); };

        vm.confirm = function() {
            if (!maskCanvas) { $uibModalInstance.close(null); return; }
            try {
                var w = maskCanvas.width, h = maskCanvas.height;
                var result = document.createElement('canvas');
                result.width = w; result.height = h;
                var rCtx = result.getContext('2d');
                rCtx.drawImage(imageCanvas, 0, 0);
                rCtx.globalCompositeOperation = 'destination-in';
                rCtx.drawImage(maskCanvas, 0, 0);
                
                var file = canvasToUploadFile(result, 'matting-result.png');

                uploadMattingFiles(file, createMaskFile(), function(result) {
                    $uibModalInstance.close(result);
                }, function() {
                    console.error('抠图结果上传失败');
                    $uibModalInstance.dismiss('error');
                });
            } catch (error) {
                console.error('抠图结果生成失败:', error);
                $uibModalInstance.dismiss('error');
            }
        };

        
        
        function createMaskFile() {
            var w = maskCanvas.width, h = maskCanvas.height;
            var maskExport = document.createElement('canvas');
            maskExport.width = w; maskExport.height = h;
            var exportCtx = maskExport.getContext('2d', { willReadFrequently: true });
            var maskData = maskCtx.getImageData(0, 0, w, h);
            var out = exportCtx.createImageData(w, h);
            for (var i = 0; i < maskData.data.length; i += 4) {
                var alpha = maskData.data[i + 3];
                var gray = alpha === 0 ? 0 : (alpha === 255 ? 255 : Math.round(30 + alpha * 180 / 255));
                out.data[i] = gray;
                out.data[i + 1] = gray;
                out.data[i + 2] = gray;
                out.data[i + 3] = 255;
            }
            exportCtx.putImageData(out, 0, 0);
            return canvasToUploadFile(maskExport, 'matting-mask.png');
        }

        function uploadMattingFiles(resultFile, maskFile, onSuccess, onError) {
            Promise.all([resultFile, maskFile]).then(function(files) {
                ImageService.backendUploadPics(files[0], vm.domain, vm.token, function(resultData) {
                    var resultUrl = vm.domain + resultData.key;
                    ImageService.backendUploadPics(files[1], vm.domain, vm.token, function(maskData) {
                        onSuccess({
                            url: resultUrl,
                            maskUrl: vm.domain + maskData.key
                        });
                    }, onError);
                }, onError);
            }).catch(onError);
        }

        function canvasToUploadFile(canvas, filename) {
            return canvasToBlob(canvas, filename).then(function(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES) {
                    return blobToFile(blob, filename);
                }
                return compressCanvasToFile(canvas, filename, blob);
            });
        }

        function compressCanvasToFile(sourceCanvas, filename, sourceBlob) {
            var currentCanvas = sourceCanvas;
            function compress(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES || currentCanvas.width <= 1 || currentCanvas.height <= 1) {
                    return blobToFile(blob, filename);
                }
                var scale = Math.sqrt(CONFIG.MAX_UPLOAD_BYTES / blob.size) * 0.92;
                scale = Math.max(0.1, Math.min(0.92, scale));
                var nextW = Math.max(1, Math.floor(currentCanvas.width * scale));
                var nextH = Math.max(1, Math.floor(currentCanvas.height * scale));
                if (nextW === currentCanvas.width && nextW > 1) nextW--;
                if (nextH === currentCanvas.height && nextH > 1) nextH--;

                var nextCanvas = document.createElement('canvas');
                nextCanvas.width = nextW;
                nextCanvas.height = nextH;
                nextCanvas.getContext('2d').drawImage(currentCanvas, 0, 0, nextW, nextH);
                currentCanvas = nextCanvas;
                return canvasToBlob(currentCanvas, filename).then(compress);
            }
            return compress(sourceBlob);
        }

        function canvasToBlob(canvas, filename) {
            return new Promise(function(resolve, reject) {
                if (canvas.toBlob) {
                    canvas.toBlob(function(blob) {
                        if (blob) resolve(blob);
                        else reject(new Error('canvas toBlob failed'));
                    }, 'image/png');
                    return;
                }
                try {
                    resolve(dataURLtoFile(canvas.toDataURL('image/png'), filename));
                } catch (error) {
                    reject(error);
                }
            });
        }

        function blobToFile(blob, filename) {
            return new File([blob], filename, { type: blob.type || 'image/png' });
        }

        function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }

        vm.setToolMode = function(mode) {
            vm.toolMode = mode;
        };

        vm.togglePanMode = function() {
            vm.panMode = !vm.panMode;
            if (vm.panMode) {
                stopDrawing();
                overlayCanvas.style.cursor = 'grab';
                effectOverlay.style.cursor = 'grab';
                brushCursorL.style.display = 'none';
                brushCursorR.style.display = 'none';
            } else {
                overlayCanvas.style.cursor = 'none';
                effectOverlay.style.cursor = 'none';
                brushCursorL.style.display = 'block';
                brushCursorR.style.display = 'block';
            }
        };

        vm.undo = function() { undo(); };
        vm.redo = function() { redo(); };
        vm.resetMask = function() { resetMask(); };

        vm.zoomIn = function() {
            var rect = wrapperL.getBoundingClientRect();
            zoomAtPoint(rect.left + rect.width / 2, rect.top + rect.height / 2, state.zoom + CONFIG.ZOOM_STEP);
        };
        vm.zoomOut = function() {
            var rect = wrapperL.getBoundingClientRect();
            zoomAtPoint(rect.left + rect.width / 2, rect.top + rect.height / 2, state.zoom - CONFIG.ZOOM_STEP);
        };
        vm.zoomReset = function() {
            state.zoom = 1; state.panX = 0; state.panY = 0;
            invalidateBrushCache(); updateTransform();
            vm.zoomPercent = '100%';
            updateBrushCursor();
        };

        function buildSliderBg(val, min, max) {
            var pct = (val - min) / (max - min) * 100;
            return 'linear-gradient(to right, #BABDC0 0%, #BABDC0 ' + pct + '%, #EAECF1 ' + pct + '%, #EAECF1 100%)';
        }

        vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
        vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
        vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);

        vm.onBrushSizeChange = function() {
            vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
            invalidateBrushCache(); showBrushSizeHint();
        };
        vm.onHardnessChange = function() {
            vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
            invalidateBrushCache();
        };
        vm.onOpacityChange = function() {
            vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);
        };

        // ==================== 初始化 ====================
        function init() {
            imageCanvas = document.getElementById('mattingImageCanvas');
            imageCtx = imageCanvas.getContext('2d');
            overlayCanvas = document.getElementById('mattingOverlayCanvas');
            overlayCtx = overlayCanvas.getContext('2d');
            effectCanvas = document.getElementById('mattingEffectCanvas');
            effectCtx = effectCanvas.getContext('2d');
            effectOverlay = document.getElementById('mattingEffectOverlay');
            effectOverlayCtx = effectOverlay.getContext('2d');

            brushCursorL = document.getElementById('mattingBrushCursorLeft');
            brushCursorR = document.getElementById('mattingBrushCursorRight');
            wrapperL = document.getElementById('mattingCanvasWrapperLeft');
            wrapperR = document.getElementById('mattingCanvasWrapperRight');
            canvasContainer = document.getElementById('mattingCanvasContainer');
            loadingOverlay = document.getElementById('mattingLoadingOverlay');
            canvasFloats = document.querySelectorAll('.matting-zoom, .matting-panel-label');

            setupEvents();
            updateBrushCursor();
            brushCursorL.style.display = 'none';
            brushCursorR.style.display = 'none';
            loadImages();
        }

        // ==================== 图片加载 ====================
        function loadImage(src) {
            return new Promise(function(resolve, reject) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = function() { resolve(img); };
                img.onerror = reject;
                img.src = src;
            });
        }

        function initMaskFromImage(maskImg) {
            var w = maskCanvas.width, h = maskCanvas.height;
            var tmp = document.createElement('canvas');
            tmp.width = w; tmp.height = h;
            var tCtx = tmp.getContext('2d', { willReadFrequently: true });
            tCtx.drawImage(maskImg, 0, 0, w, h);
            var data = tCtx.getImageData(0, 0, w, h).data;
            var out = maskCtx.createImageData(w, h);
            for (var i = 0; i < data.length; i += 4) {
                var bright = (data[i] + data[i + 1] + data[i + 2]) / 3;
                out.data[i] = CONFIG.MASK_GREEN.r;
                out.data[i + 1] = CONFIG.MASK_GREEN.g;
                out.data[i + 2] = CONFIG.MASK_GREEN.b;
                if (bright < 30) out.data[i + 3] = 0;
                else if (bright > 210) out.data[i + 3] = 255;
                else out.data[i + 3] = Math.floor(255 * (bright - 30) / 180);
            }
            maskCtx.putImageData(out, 0, 0);
        }

        function loadImages() {
            Promise.all([
                loadImage(entity.originalImage),
                loadImage(entity.maskImage)
            ]).then(function(results) {
                var orig = results[0], mask = results[1];
                state.originalImg = orig; state.maskImg = mask;

                var cr = canvasContainer.getBoundingClientRect();
                var panelW = (cr.width - 16 - 4) / 2;
                var panelH = cr.height - 40;
                var aspect = orig.width / orig.height;
                var dW, dH;
                if (panelW / panelH > aspect) { dH = panelH; dW = dH * aspect; }
                else { dW = panelW; dH = dW / aspect; }
                state.displayW = dW; state.displayH = dH;

                maskCanvas = document.createElement('canvas');
                maskCanvas.width = orig.width;
                maskCanvas.height = orig.height;
                maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });

                [imageCanvas, effectCanvas, overlayCanvas, effectOverlay].forEach(function(c) {
                    c.width = orig.width;
                    c.height = orig.height;
                });

                var sizeCss = [imageCanvas, effectCanvas, overlayCanvas, effectOverlay];
                sizeCss.forEach(function(c) {
                    c.style.width = dW + 'px';
                    c.style.height = dH + 'px';
                });

                imageCtx.drawImage(orig, 0, 0);
                initMaskFromImage(mask);
                state.initialMask = document.createElement('canvas');
                state.initialMask.width = maskCanvas.width;
                state.initialMask.height = maskCanvas.height;
                state.initialMask.getContext('2d').drawImage(maskCanvas, 0, 0);
                renderBoth();
                pushHistory();
                loadingOverlay.style.display = 'none';
            }).catch(function(err) {
                loadingOverlay.innerHTML = '<span>加载失败，请刷新重试</span>';
                console.error(err);
            });
        }

        // ==================== 渲染 ====================
        function isCanvasReady() {
            return !!(maskCanvas && maskCtx && imageCanvas && overlayCanvas && effectCanvas && effectOverlay);
        }

        function renderBoth() {
            if (!isCanvasReady()) return;
            overlayCtx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);
            overlayCtx.drawImage(maskCanvas, 0, 0);
            imageCanvas.style.visibility = 'visible';
            overlayCanvas.style.opacity = '0.5';
            overlayCanvas.style.display = 'block';

            var w = effectCanvas.width, h = effectCanvas.height;
            effectCtx.clearRect(0, 0, w, h);
            effectCtx.drawImage(imageCanvas, 0, 0);
            effectCtx.globalCompositeOperation = 'destination-in';
            effectCtx.drawImage(maskCanvas, 0, 0);
            effectCtx.globalCompositeOperation = 'source-over';

            effectOverlayCtx.clearRect(0, 0, w, h);
            effectOverlay.style.opacity = '1';
            effectOverlay.style.display = 'block';
        }

        // ==================== 画笔缓存 ====================
        function invalidateBrushCache() { brushTipCacheKey = ''; }

        function getBrushTip() {
            if (!isCanvasReady()) return null;
            var ratio = maskCanvas.width / state.displayW / state.zoom;
            var brushRadius = Math.max(1, vm.brushSize / 2 * ratio);
            var hardness = vm.hardness / 100;
            var innerR = brushRadius * hardness;
            var outerR = Math.max(brushRadius, innerR + 1);
            var size = Math.ceil(outerR * 2);
            var key = brushRadius.toFixed(2) + '|' + hardness.toFixed(2);

            if (brushTipCacheKey === key && brushTipCache) return { tip: brushTipCache, innerR: innerR, outerR: outerR };

            brushTipCacheKey = key;
            if (!brushTipCache || brushTipCache.width !== size || brushTipCache.height !== size) {
                brushTipCache = document.createElement('canvas');
                brushTipCache.width = size; brushTipCache.height = size;
            }
            var tctx = brushTipCache.getContext('2d');
            tctx.clearRect(0, 0, brushTipCache.width, brushTipCache.height);
            var cx = outerR, cy = outerR;
            var mc = CONFIG.MASK_GREEN;
            var solidColor = 'rgb(' + mc.r + ',' + mc.g + ',' + mc.b + ')';
            var fadeColor = 'rgba(' + mc.r + ',' + mc.g + ',' + mc.b + ',0)';
            if (innerR >= outerR - 0.5) {
                tctx.fillStyle = solidColor;
                tctx.beginPath(); tctx.arc(cx, cy, brushRadius, 0, Math.PI * 2); tctx.fill();
            } else {
                var grad = tctx.createRadialGradient(cx, cy, innerR, cx, cy, outerR);
                grad.addColorStop(0, solidColor);
                grad.addColorStop(1, fadeColor);
                tctx.fillStyle = grad;
                tctx.beginPath(); tctx.arc(cx, cy, outerR, 0, Math.PI * 2); tctx.fill();
            }
            return { tip: brushTipCache, innerR: innerR, outerR: outerR };
        }

        // ==================== 坐标 ====================
        function updateTransform() {
            var t = 'scale(' + state.zoom + ') translate(' + state.panX + 'px, ' + state.panY + 'px)';
            wrapperL.style.transformOrigin = '0 0';
            wrapperL.style.transform = t;
            wrapperR.style.transformOrigin = '0 0';
            wrapperR.style.transform = t;
        }

        function zoomAtPoint(clientX, clientY, newZoom) {
            newZoom = Math.max(CONFIG.MIN_ZOOM, Math.min(CONFIG.MAX_ZOOM, newZoom));
            var lPanelRect = document.getElementById('mattingLeftPanel').getBoundingClientRect();
            var isOverRight = clientX > lPanelRect.right;
            var rect = isOverRight ? wrapperR.getBoundingClientRect() : wrapperL.getBoundingClientRect();
            var lx = (clientX - rect.left) / state.zoom;
            var ly = (clientY - rect.top) / state.zoom;
            state.panX = (lx + state.panX) * state.zoom / newZoom - lx;
            state.panY = (ly + state.panY) * state.zoom / newZoom - ly;
            state.zoom = newZoom;
            invalidateBrushCache();
            updateTransform();
            vm.zoomPercent = Math.round(state.zoom * 100) + '%';
            updateBrushCursor({ clientX: clientX, clientY: clientY });
        }

        function getCanvasPos(e, wrapper) {
            if (!isCanvasReady()) return null;
            var rect = wrapper.getBoundingClientRect();
            var clientX = e.touches ? e.touches[0].clientX : e.clientX;
            var clientY = e.touches ? e.touches[0].clientY : e.clientY;
            var ratio = maskCanvas.width / state.displayW;
            return {
                x: (clientX - rect.left) / state.zoom * ratio,
                y: (clientY - rect.top) / state.zoom * ratio,
            };
        }

        // ==================== 历史 ====================
        function pushHistory() {
            if (!isCanvasReady()) return;
            state.history.length = state.historyIndex + 1;
            var snap = document.createElement('canvas');
            snap.width = maskCanvas.width; snap.height = maskCanvas.height;
            snap.getContext('2d').drawImage(maskCanvas, 0, 0);
            state.history.push(snap);
            if (state.history.length > CONFIG.MAX_HISTORY) { state.history.shift(); }
            else { state.historyIndex = state.history.length - 1; }
            updateUndoRedoState();
        }

        function undo() {
            if (state.historyIndex <= 0) return;
            state.historyIndex--;
            restoreMaskFromHistory();
        }
        function redo() {
            if (state.historyIndex >= state.history.length - 1) return;
            state.historyIndex++;
            restoreMaskFromHistory();
        }
        function restoreMaskFromHistory() {
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(state.history[state.historyIndex], 0, 0);
            updateUndoRedoState();
            renderBoth();
        }
        function resetMask() {
            if (!state.initialMask) return;
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(state.initialMask, 0, 0);
            pushHistory();
            renderBoth();
            vm.zoomReset();
            MessageService.success('已重置');
        }
        function updateUndoRedoState() {
            vm.undoEnabled = state.historyIndex > 0;
            vm.redoEnabled = state.historyIndex < state.history.length - 1;
            scheduleUndoRedoDigest();
        }

        function scheduleUndoRedoDigest() {
            if (undoRedoDigestTimer) return;
            undoRedoDigestTimer = $timeout(function() {
                undoRedoDigestTimer = null;
            }, 0);
        }

        // ==================== 绘画 ====================
        function ensureStrokeCanvases() {
            if (!isCanvasReady()) return;
            if (strokeCanvas && strokeCanvas.width === maskCanvas.width && strokeCanvas.height === maskCanvas.height && strokeAlphaData) return;
            strokeCanvas = document.createElement('canvas');
            strokeCanvas.width = maskCanvas.width;
            strokeCanvas.height = maskCanvas.height;
            strokeCtx = strokeCanvas.getContext('2d');
            strokeAlphaData = new Uint8ClampedArray(maskCanvas.width * maskCanvas.height);

            strokeBaseCanvas = document.createElement('canvas');
            strokeBaseCanvas.width = maskCanvas.width;
            strokeBaseCanvas.height = maskCanvas.height;
            strokeBaseCtx = strokeBaseCanvas.getContext('2d');
        }

        function beginStroke() {
            ensureStrokeCanvases();
            if (!strokeCanvas || !strokeBaseCanvas) return;
            strokeBaseCtx.clearRect(0, 0, strokeBaseCanvas.width, strokeBaseCanvas.height);
            strokeBaseCtx.drawImage(maskCanvas, 0, 0);
            strokeCtx.clearRect(0, 0, strokeCanvas.width, strokeCanvas.height);
            strokeAlphaData.fill(0);
            strokeDirtyRect = null;
        }

        function getBrushPixelAlpha(distance, td) {
            if (distance <= td.innerR) return 255;
            if (distance >= td.outerR) return 0;
            return Math.round(255 * (1 - (distance - td.innerR) / (td.outerR - td.innerR)));
        }

        function drawBrushStamp(x, y, td) {
            td = td || getBrushTip();
            if (!td || !strokeAlphaData) return;
            var x1 = Math.max(0, Math.floor(x - td.outerR));
            var y1 = Math.max(0, Math.floor(y - td.outerR));
            var x2 = Math.min(strokeCanvas.width, Math.ceil(x + td.outerR));
            var y2 = Math.min(strokeCanvas.height, Math.ceil(y + td.outerR));
            for (var py = y1; py < y2; py++) {
                for (var px = x1; px < x2; px++) {
                    var dx = px + 0.5 - x;
                    var dy = py + 0.5 - y;
                    var distance = Math.sqrt(dx * dx + dy * dy);
                    var alpha = getBrushPixelAlpha(distance, td);
                    if (!alpha) continue;
                    var index = py * strokeCanvas.width + px;
                    if (alpha > strokeAlphaData[index]) strokeAlphaData[index] = alpha;
                }
            }
            addStrokeDirtyRect(x, y, td.outerR);
        }

        function syncStrokeCanvasRect(rect) {
            if (!strokeAlphaData || !strokeCtx) return;
            var imageData = strokeCtx.createImageData(rect.w, rect.h);
            var data = imageData.data;
            var mc = CONFIG.MASK_GREEN;
            var di = 0;
            for (var y = 0; y < rect.h; y++) {
                var si = (rect.y + y) * strokeCanvas.width + rect.x;
                for (var x = 0; x < rect.w; x++, si++, di += 4) {
                    var alpha = strokeAlphaData[si];
                    data[di] = mc.r;
                    data[di + 1] = mc.g;
                    data[di + 2] = mc.b;
                    data[di + 3] = alpha;
                }
            }
            strokeCtx.putImageData(imageData, rect.x, rect.y);
        }

        function ensureEffectPatchCanvas(w, h) {
            if (!effectPatchCanvas) {
                effectPatchCanvas = document.createElement('canvas');
                effectPatchCtx = effectPatchCanvas.getContext('2d');
            }
            if (effectPatchCanvas.width < w) effectPatchCanvas.width = w;
            if (effectPatchCanvas.height < h) effectPatchCanvas.height = h;
        }

        function renderEffectRect(rect) {
            ensureEffectPatchCanvas(rect.w, rect.h);
            effectPatchCtx.clearRect(0, 0, rect.w, rect.h);
            effectPatchCtx.save();
            effectPatchCtx.globalCompositeOperation = 'source-over';
            effectPatchCtx.drawImage(imageCanvas, rect.x, rect.y, rect.w, rect.h, 0, 0, rect.w, rect.h);
            effectPatchCtx.globalCompositeOperation = 'destination-in';
            effectPatchCtx.drawImage(maskCanvas, rect.x, rect.y, rect.w, rect.h, 0, 0, rect.w, rect.h);
            effectPatchCtx.restore();

            effectCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
            effectCtx.drawImage(effectPatchCanvas, 0, 0, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
        }

        function renderStrokeToMask() {
            if (!isCanvasReady() || !strokeCanvas || !strokeBaseCanvas || !strokeDirtyRect) return;
            var rect = {
                x: strokeDirtyRect.x,
                y: strokeDirtyRect.y,
                w: strokeDirtyRect.x2 - strokeDirtyRect.x,
                h: strokeDirtyRect.y2 - strokeDirtyRect.y
            };
            strokeDirtyRect = null;
            syncStrokeCanvasRect(rect);

            maskCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
            maskCtx.drawImage(strokeBaseCanvas, rect.x, rect.y, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
            maskCtx.save();
            maskCtx.globalAlpha = vm.opacity / 100;
            if (vm.toolMode === 'erase') maskCtx.globalCompositeOperation = 'destination-out';
            maskCtx.drawImage(strokeCanvas, rect.x, rect.y, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
            maskCtx.restore();

            if (state.activeSide === 'right') {
                effectOverlayCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
                renderEffectRect(rect);
            } else {
                overlayCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
                overlayCtx.drawImage(maskCanvas, rect.x, rect.y, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
            }
        }

        function drawBrushAt(x, y, td) {
            drawBrushStamp(x, y, td);
        }

        function getBrushStampSpacing(td) {
            if (!td || !maskCanvas || !state.displayW) return 3;
            var imagePxPerScreenPx = maskCanvas.width / state.displayW / state.zoom;
            var screenGap = Math.max(1.5, Math.min(3, vm.brushSize * 0.1));
            return Math.max(1, Math.min(td.outerR * 0.25, screenGap * imagePxPerScreenPx));
        }

        function drawLine(from, to) {
            var dx = to.x - from.x, dy = to.y - from.y;
            var dist = Math.sqrt(dx * dx + dy * dy);
            var td = getBrushTip();
            if (dist === 0) { drawBrushAt(from.x, from.y, td); return; }
            var spacing = getBrushStampSpacing(td);
            var steps = Math.ceil(dist / spacing);
            for (var i = 0; i <= steps; i++) {
                var t = i / steps;
                drawBrushAt(from.x + dx * t, from.y + dy * t, td);
            }
        }

        var pendingRafPos = null, lastRafDrawnPos = null, rafDrawId = null;
        var strokeDirtyRect = null;
        var lastDrawFrameTime = 0;

        function addStrokeDirtyRect(x, y, radius) {
            if (!isCanvasReady()) return;
            var x1 = Math.max(0, Math.floor(x - radius - 1));
            var y1 = Math.max(0, Math.floor(y - radius - 1));
            var x2 = Math.min(maskCanvas.width, Math.ceil(x + radius + 1));
            var y2 = Math.min(maskCanvas.height, Math.ceil(y + radius + 1));
            if (x2 <= x1 || y2 <= y1) return;
            if (!strokeDirtyRect) {
                strokeDirtyRect = { x: x1, y: y1, x2: x2, y2: y2 };
                return;
            }
            strokeDirtyRect.x = Math.min(strokeDirtyRect.x, x1);
            strokeDirtyRect.y = Math.min(strokeDirtyRect.y, y1);
            strokeDirtyRect.x2 = Math.max(strokeDirtyRect.x2, x2);
            strokeDirtyRect.y2 = Math.max(strokeDirtyRect.y2, y2);
        }

        function flushRafDraw(frameTime) {
            rafDrawId = null;
            if (!state.isDrawing || !pendingRafPos) return;
            frameTime = frameTime || Date.now();
            if (lastDrawFrameTime && frameTime - lastDrawFrameTime < 24) {
                rafDrawId = requestAnimationFrame(flushRafDraw);
                return;
            }
            lastDrawFrameTime = frameTime;
            var target = pendingRafPos;
            pendingRafPos = null;
            if (lastRafDrawnPos) { drawLine(lastRafDrawnPos, target); }
            else { drawBrushAt(target.x, target.y); }
            renderStrokeToMask();
            lastRafDrawnPos = target;
        }

        function scheduleDraw(pos) {
            if (!state.isDrawing || !pos) return;
            pendingRafPos = pos;
            if (!rafDrawId) rafDrawId = requestAnimationFrame(flushRafDraw);
        }

        function startDrawing(e, wrapper) {
            if (!isCanvasReady()) return;
            state.isDrawing = true;
            state.activeSide = (wrapper === wrapperL) ? 'left' : 'right';
            beginStroke();
            lastDrawFrameTime = 0;
            var pos = getCanvasPos(e, wrapper);
            if (!pos) {
                state.isDrawing = false;
                return;
            }
            lastRafDrawnPos = pos;
            pendingRafPos = null;
            canvasFloats.forEach(function(el) { el.classList.add('matting-float-hidden'); });
            scheduleDraw(pos);
        }

        function stopDrawing() {
            var hadDrawing = state.isDrawing || rafDrawId || pendingRafPos || lastRafDrawnPos;
            if (rafDrawId) {
                cancelAnimationFrame(rafDrawId);
                rafDrawId = null;
                if (pendingRafPos && lastRafDrawnPos) {
                    drawLine(lastRafDrawnPos, pendingRafPos);
                    renderStrokeToMask();
                }
            }
            state.isDrawing = false;
            pendingRafPos = null; lastRafDrawnPos = null;
            strokeDirtyRect = null;
            lastDrawFrameTime = 0;
            if (hadDrawing) {
                renderBoth();
                pushHistory();
            }
            canvasFloats.forEach(function(el) { el.classList.remove('matting-float-hidden'); });
        }

        // ==================== 光标 ====================
        var lastMouseX = -1, lastMouseY = -1;

        function updateBrushCursor(e) {
            var cx, cy;
            if (e) {
                cx = e.touches ? e.touches[0].clientX : e.clientX;
                cy = e.touches ? e.touches[0].clientY : e.clientY;
                lastMouseX = cx; lastMouseY = cy;
            } else if (lastMouseX >= 0) {
                cx = lastMouseX; cy = lastMouseY;
            } else { return; }

            var lPanelRect = document.getElementById('mattingLeftPanel').getBoundingClientRect();
            var lRect = wrapperL.getBoundingClientRect();
            var rRect = wrapperR.getBoundingClientRect();

            [brushCursorL, brushCursorR].forEach(function(c) {
                var rect = (c === brushCursorR) ? rRect : lRect;
                c.style.left = ((cx - rect.left) / state.zoom) + 'px';
                c.style.top = ((cy - rect.top) / state.zoom) + 'px';
                var cs = vm.brushSize / state.zoom;
                c.style.width = cs + 'px'; c.style.height = cs + 'px';
            });

            if (!vm.panMode && !state.spaceHeld) {
                brushCursorL.style.display = 'block';
                brushCursorR.style.display = 'block';
            }
        }

        function showBrushSizeHint() {
            vm.brushHintVisible = true;
            if (hintTimer) $timeout.cancel(hintTimer);
            hintTimer = $timeout(function() {
                vm.brushHintVisible = false;
            }, 800);
        }

        // ==================== 事件绑定 ====================
        function setupEvents() {
            canvasContainer.addEventListener('wheel', function(e) {
                e.preventDefault();
                var d = e.deltaY > 0 ? -CONFIG.ZOOM_STEP : CONFIG.ZOOM_STEP;
                zoomAtPoint(e.clientX, e.clientY, state.zoom + d);
            }, { passive: false });

            bindCanvasEvents(overlayCanvas, wrapperL);
            bindCanvasEvents(effectOverlay, wrapperR);

            canvasContainer.addEventListener('mouseenter', function() {
                clearTimeout(cursorHideTimer);
                cursorHideTimer = null;
                if (!vm.panMode && !state.spaceHeld) { brushCursorL.style.display = 'block'; brushCursorR.style.display = 'block'; }
            });
            canvasContainer.addEventListener('mouseleave', function() {
                stopDrawing();
                cursorHideTimer = setTimeout(function() {
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                }, 80);
            });

            document.addEventListener('keydown', function(e) {
                if (e.target.tagName === 'INPUT') return;
                if (e.code === 'Space' && !state.spaceHeld) {
                    e.preventDefault(); state.spaceHeld = true;
                    if (!vm.panMode) {
                        stopDrawing();
                        overlayCanvas.style.cursor = 'grab';
                        effectOverlay.style.cursor = 'grab';
                        brushCursorL.style.display = 'none';
                        brushCursorR.style.display = 'none';
                    }
                }
                if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) { e.preventDefault(); undo(); }
                if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) { e.preventDefault(); redo(); }
            });
            document.addEventListener('keyup', function(e) {
                if (e.code === 'Space') {
                    state.spaceHeld = false; state.isPanning = false;
                    if (!vm.panMode) {
                        overlayCanvas.style.cursor = 'none';
                        effectOverlay.style.cursor = 'none';
                        brushCursorL.style.display = 'block';
                        brushCursorR.style.display = 'block';
                    }
                }
            });

            updateUndoRedoState();
        }

        function bindCanvasEvents(canvas, wrapper) {
            canvas.addEventListener('mousedown', function(e) {
                if (vm.panMode || state.spaceHeld) {
                    state.isPanning = true;
                    state.panStart = { x: state.panX, y: state.panY };
                    state.panScreenStart = { x: e.clientX, y: e.clientY };
                    canvas.style.cursor = 'grabbing';
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                    return;
                }
                startDrawing(e, wrapper);
            });
            canvas.addEventListener('mousemove', function(e) {
                if (state.isPanning) {
                    state.panX = state.panStart.x + (e.clientX - state.panScreenStart.x) / state.zoom;
                    state.panY = state.panStart.y + (e.clientY - state.panScreenStart.y) / state.zoom;
                    updateTransform(); return;
                }
                updateBrushCursor(e);
                if (state.isDrawing) scheduleDraw(getCanvasPos(e, wrapper));
            });
            canvas.addEventListener('mouseup', function() {
                if (state.isPanning) {
                    state.isPanning = false;
                    canvas.style.cursor = (vm.panMode || state.spaceHeld) ? 'grab' : 'none';
                    if (!vm.panMode && !state.spaceHeld) { brushCursorL.style.display = 'block'; brushCursorR.style.display = 'block'; }
                    return;
                }
                stopDrawing();
            });

            canvas.addEventListener('touchstart', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2) {
                    stopDrawing(); state.isPinching = true;
                    state.pinchStartDist = touchDist(e);
                    state.pinchLastMid = touchMid(e);
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                    return;
                }
                brushCursorL.style.display = 'block'; brushCursorR.style.display = 'block';
                updateBrushCursor(e); startDrawing(e, wrapper);
            }, { passive: false });

            canvas.addEventListener('touchmove', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2 && state.isPinching) {
                    var nd = touchDist(e), mid = touchMid(e);
                    zoomAtPoint(mid.x, mid.y, state.zoom * (nd / state.pinchStartDist));
                    if (state.pinchLastMid) {
                        state.panX += (mid.x - state.pinchLastMid.x) / state.zoom;
                        state.panY += (mid.y - state.pinchLastMid.y) / state.zoom;
                        updateTransform();
                    }
                    state.pinchStartDist = nd; state.pinchLastMid = mid; return;
                }
                if (e.touches.length === 1 && !state.isPinching) {
                    updateBrushCursor(e);
                    if (state.isDrawing) scheduleDraw(getCanvasPos(e, wrapper));
                }
            }, { passive: false });

            canvas.addEventListener('touchend', function(e) {
                if (e.touches.length === 0) {
                    state.isPinching = false;
                    stopDrawing();
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                } else if (e.touches.length === 1 && state.isPinching) {
                    state.isPinching = false;
                }
            });
        }

        function touchDist(e) {
            var dx = e.touches[0].clientX - e.touches[1].clientX;
            var dy = e.touches[0].clientY - e.touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function touchMid(e) {
            return {
                x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                y: (e.touches[0].clientY + e.touches[1].clientY) / 2
            };
        }

        // ==================== 启动 ====================
        $timeout(init);
    }
})();
